export default "/_next/static/images/texture-6-5e6c167f09d3f5ce541b875e2875a70d.png";